<template>
  <skeleton v-if="data.objectID === 'skeleton'" height="1.5rem" />
  <text-icon v-else :icon="icon" :value="label" />
</template>
<script setup>
import { computed } from "vue";

import Skeleton from "primevue/skeleton";

import TextIcon from "@/components/shared/TextIcon.vue";
import { getParticipantStatusLabel, getParticipantStatusIcon } from "../participantStatus.js";

const props = defineProps({
  data: {
    type: Object,
    default: undefined,
  },
});

const icon = computed(() => {
  return getParticipantStatusIcon(props.data.student.status)?.value;
});

const label = computed(() => {
  return getParticipantStatusLabel(props.data.student.status);
});
</script>
